module.exports = __webpack_public_path__ + "img/09498335000318.c1c29fa9.png";